import React, { useState, useCallback } from "react";

import "./FileDropZone.scss";
import {
  BrowseToSelectFile,
  DragAndDropYourFileHere,
  DragYourFileHere,
} from "../../utils/Constant";
import H3 from "../Headings/H3Element";
import MUIIcons from "../MUIIcon/MUIIcons";
import P from "../Paragraph";

interface FileDropZoneProps {
  onFileSelect: (file: File) => void;
}

export const FileDropZone: React.FC<FileDropZoneProps> = ({ onFileSelect }) => {
  const [isDragActive, setIsDragActive] = useState(false);

  const handleDragEnter = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(true);
  }, []);

  const handleDragLeave = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(false);
  }, []);

  const handleDragOver = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleDrop = useCallback(
    (e: React.DragEvent) => {
      e.preventDefault();
      e.stopPropagation();
      setIsDragActive(false);

      const files = Array.from(e.dataTransfer.files);
      if (files.length > 0) {
        onFileSelect(files[0]);
      }
    },
    [onFileSelect]
  );

  return (
    <div
      className={`file-drop-zone ${isDragActive ? "drag-active" : ""}`}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      <div className="drop-zone-content">
        <div className="drop-zone-icon">
          {isDragActive ? (
            <MUIIcons
              iconName="UploadFileOutlined"
              className="primary-icon-color"
              size={24}
            />
          ) : (
            <MUIIcons
              iconName="ImageOutlined"
              className="primary-icon-color"
              size={24}
            />
          )}
        </div>
        <H3>{isDragActive ? DragYourFileHere : DragAndDropYourFileHere}</H3>
        <P>{BrowseToSelectFile}</P>
      </div>
    </div>
  );
};
